<template>
  <div id="CurveSearch" class="transition-200 curve-form" :class="isFastSearchPage ? 'normal-form': 'inline-form'">
    <el-form :model="curveForm" :inline="!isFastSearchPage" @submit.native.prevent>
      <template v-for="item in curveFormItems">
          <el-form-item
              :key="item.code"
              :label="item.label"
          >
            <template>
              <!--整数类型-->
              <el-input
                  v-if="item.dataType === 'Int'"
                  :size="isFastSearchPage?'medium':'mini'"
                  class="input-normal"
                  :class="{'input-error':errorCodes.includes(item.code)}"
                  placeholder="请输入"
                  v-model.number.trim="curveForm[item.code]"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  @keyup.enter.native.stop="startSearch"
                  @blur="onBlur"
              >
                <template v-if="item.suffix" #append>{{item.suffix}}</template>
              </el-input>
              <!--小数类型-->
              <el-input
                  v-if="item.dataType === 'Number'"
                  :size="isFastSearchPage?'medium':'mini'"
                  class="input-normal"
                  :class="{'input-append-select':item.suffixes,'input-error':errorCodes.includes(item.code)}"
                  placeholder="请输入"
                  v-model="curveForm[item.code]"
                  oninput="value = value.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.').replace(/(\.\d+)\./g, '$1').replace(/^0+(\d)/g, '$1').replace(/(\d+\.[\d]{2}).*$/g,'$1')"
                  @keyup.enter.native.stop="startSearch"
                  @blur="onBlur"
              >
                <template v-if="item.suffixes" #append>
                  <el-select v-model="units[item.code]" class="select-unit" @change="onUnitChanged(item)">
                    <el-option
                      v-for="s in item.suffixes"
                      :key="s"
                      :label="s"
                      :value="s"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else #append>{{item.suffix}}</template>
              </el-input>
              <template v-if="!isFastSearchPage">
                <span class="deviation-symbol">±</span>
                <el-input
                    class="narrow"
                    v-model="deviation[item.code]"
                    oninput="value=value.replace(/[^\d]/g,'').replace(/^0+(\d)/, '$1').replace(/([\d]{2}).*$/g,'$1')"
                    placeholder="偏差率"
                    @keyup.enter.native.stop="deviationChange(item.code)">
                  <template #append>%</template>
                </el-input>
              </template>
            </template>
          </el-form-item>
        </template>
    </el-form>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CurveSearch',
  props: {
    // 区分列表页（list） or 快速搜索页面(fastSearch)，因为搜索行为不一致
    pageType: {
      type: String,
      default() {
        return 'list'
      }
    },
    speedControl: {
      type: String,
      default: ''
    },
    curveFormItems: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      curveForm: {},
      // 形如：{ code:偏差率 }
      deviation: {},
      // 形如：{ code:单位 }
      units: {},
      errorCodes: [],
      curveSearchValues: [],
    }
  },
  computed: {
    ...mapGetters({
      convertUnits: 'pumpList/convertUnits',
      initCurveSearchValue: 'fastSearch/initCurveSearchValue',
      isFromEntrance: 'isFromEntrance',
    }),
    isFastSearchPage() {
      return this.pageType === 'fastSearch'
    },
    handleUnitsValue() {
      const obj = {}
      this.convertUnits.forEach((item) => {
        const { code, unit } = item
        obj[code] = unit
      })
      return obj
    },
    requiredCodes() {
      return this.getCodes((item) => item.required)
    },
    allowSearch() {
      return !this.errorCodes.length
    },
  },
  watch: {
    initCurveSearchValue: {
      handler(newVal) {
        const { curveForm, deviation } = newVal
        this.curveForm = { ...curveForm }
        this.deviation = { ...deviation }
        this.units = this.handleUnitsValue
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    ...mapMutations({
    }),
    getCodes(fn) {
      if (fn) {
        return this.curveFormItems.filter((item) => {
          return fn(item)
        }).map((it) => it.code)
      } else {
        return this.curveFormItems.map((it) => it.code)
      }
    },
    clearData() {
      this.curveForm = {}
      this.deviation = {}
      this.errorCodes = []
    },
    clearDeviation(deviation) {
      this.deviation[deviation.code] = null
    },
    getErrCodes() {
      if (this.isFromEntrance) { return }
      const searchData = this.curveForm
      const keys = Object.keys(searchData)
      if (keys.some((k) => searchData[k])) {
        this.errorCodes = this.requiredCodes.reduce((arr, rc) => {
          if (!searchData[rc]) {
            arr.push(rc)
          }
          return arr
        }, [])
      } else {
        this.errorCodes = []
      }
      console.log('this.errorCodes:', this.errorCodes)
    },
    deviationChange(code) {
      if (!this.curveForm[code] && this.curveForm[code] !== 0) {
        return
      }
      this.startSearch()
    },
    startSearch() {
      this.getErrCodes()
      if (this.pageType === 'fastSearch' || this.allowSearch) {
        const curveProperties = []
        this.curveFormItems.forEach((item) => {
          const value = this.curveForm[item.code]
          const deviationRate = this.deviation[item.code]
          curveProperties.push({
            code: item.code,
            label: item.label, // 用于展示筛选条件的名称
            value,
            unit: item.suffix,
            deviationRate: deviationRate && value ? Number(deviationRate) : null 
          })
        })
        console.log('curveProperties', curveProperties)
        // curveProperties包含了所有性能搜索属性信息
        this.$emit('curve-search', curveProperties)
      }
    },
    onBlur() {
      if (this.pageType === 'fastSearch') {
        this.startSearch()
      }
    },
    onUnitChanged(item) {
      item.suffix = this.units[item.code]
      this.$emit('change-unit', item)
    }
  },
}
</script>
<style lang='less' scoped>
#CurveSearch{
  /deep/ .el-form-item__content .el-input-group{
    vertical-align: unset;
  }
}
.curve-form{
  margin-bottom: -4px;
}
.inline-form{
  /deep/ .el-form-item{
    margin-bottom: 4px;
    height: 28px;
    display: inline-flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
  .input-normal{
    width: 116px;
    &.input-append-select{
      /deep/.el-input-group__append{
        width: 58px;
        text-align: center;
      }
    }
  }
}
.normal-form{
  /deep/ .el-form-item{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-left: -168px;
  }
  /deep/ .el-form-item__label{
    text-align: right;
    width: 220px;
  }
  .input-normal{
    width: 220px;
    /deep/.el-input-group__append{
      width: 72px;
      text-align: center;
    }
  }
}
.input-normal{
  .select-unit{
    width: 100%;
  }
  &.input-append-select{
    /deep/.el-input-group__append{
      text-align: center;
    }
    /deep/.el-input__suffix{
      right: -10px;
    }
  }
}
.input-error{
    /deep/ .el-input__inner{
      border: 1px solid red;
    }
  }
.narrow{
  width: 80px;
}
.deviation-symbol{
  display: inline-block;
  line-height: 28px;
  margin: 0 4px 0 8px;
}
</style>
